import { Component, HostListener } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ApiUrlHelper } from 'src/app/common/apiUrlHelper';
import { ChangePasswordModel } from 'src/app/models/changePasswordModel';
import { CommonService } from 'src/app/services/common/common.service';
import { ToastrService } from 'ngx-toastr';
import { NgxSpinnerService } from 'ngx-spinner';
import { Router } from '@angular/router';
import { ChangePasswordConstant } from 'src/app/constants/label-constants';
import { SharedService } from 'src/app/services/shared.service';
import { changePasswordErrorMessage } from 'src/app/constants/error-message-constant';

@Component({
  selector: 'app-change-password',
  templateUrl: './change-password.component.html',
  styleUrls: ['./change-password.component.css']
})
export class ChangePasswordComponent {
  changePasswordForm: FormGroup = this.formBuilder.group({});
  IsShowOldPassword: boolean = false;
  IsShowNewPassword: boolean = false;
  IsShowConfirmPassword: boolean = false;
  initalValues: any;
  errorMessage:any=[];
  saveStatus: boolean = false;
  isSubmitted: boolean =false;
  changePasswordconstant: any =[];
  @HostListener('window:beforeunload', ['$event'])
  public canDeactivate(event: any): boolean {
    if (event.type == 'beforeunload') {
      if (this.changePasswordForm.dirty) {
        event.preventDefault();
        if(!this.commonService.isSystemAlert)
        {
          event.returnValue = false;
        }
      }
      return this.changePasswordForm.dirty;
    }
    else {
      this.commonService.href = (event.currentTarget as HTMLAnchorElement).href;
      return this.changePasswordForm.dirty;
    }
  }
  constructor(private formBuilder: FormBuilder,
    private apiUrl: ApiUrlHelper,
    public commonService: CommonService,
    private sharedService: SharedService,
    private toster: ToastrService,
    private spinner: NgxSpinnerService, 
    private router: Router) {     
    }

  ngOnInit(): void {
    this.changePasswordconstant = ChangePasswordConstant;
    this.errorMessage=changePasswordErrorMessage;
    this.sharedService.setData('Change Password');
    this.initChangePasswordForm();
  }

  initChangePasswordForm() {
    this.changePasswordForm = this.formBuilder.group({
      oldPassword: ['', Validators.required],
      newPassword: ['', [Validators.required, Validators.pattern(/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d).{6,}$/)]],
      ConfirmPassword: ['', [Validators.required, Validators.pattern(/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d).{6,}$/)]]
    });  
  }

  onPaste(event: ClipboardEvent) {
    event.preventDefault();
  }

  ChangePassword() {
    this.isSubmitted=true;
    if (!this.changePasswordForm.valid) {
      return
    }
    this.spinner.show();
    const userId = Number(localStorage.getItem('userId'));
    const objData: ChangePasswordModel = {
      UserId: userId,
      OldPassword: this.changePasswordForm.value.oldPassword,
      CreatePassword: this.changePasswordForm.value.newPassword,
      ConfirmPassword: this.changePasswordForm.value.ConfirmPassword
    }
    const apiUrl = this.apiUrl.apiUrl.forgotPassword.ChangePassword;
    this.commonService.doPut(apiUrl, objData).pipe().subscribe({
      next: async (response) => {
        if (response.success) {
          this.changePasswordForm.reset();
          this.isSubmitted=false;
          this.spinner.hide();
          this.toster.success(response.message);
          localStorage.clear();
          this.router.navigate(['/login']);
        }
        else {
          this.spinner.hide();
          this.toster.error(response.message);
        }
      },
      error: (error) => {
        this.spinner.hide();
        this.toster.error(error.message)
      }
    });
  }
  get changePasswordFormControl() {
    return this.changePasswordForm.controls;
  }
  showNewPassword() {
    this.IsShowNewPassword = !this.IsShowNewPassword;
  }
  showOldPassword() {
    this.IsShowOldPassword = !this.IsShowOldPassword;
  }
  showConfirmPassword() {
    this.IsShowConfirmPassword = !this.IsShowConfirmPassword;
  }
}
